export default __webpack_public_path__ + "1f5c34d6311880dd34a5120784ea01dc.png";